import React, { useState } from "react";

const CloudSimulator = () => {
  const [numSystems, setNumSystems] = useState(2);
  const [systems, setSystems] = useState([]);
  const [folders, setFolders] = useState({});
  const [folderName, setFolderName] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("doc");
  const [selectedFolder, setSelectedFolder] = useState("");
  const [accessPanelVisible, setAccessPanelVisible] = useState(false);
  const [currentFolderForAccess, setCurrentFolderForAccess] = useState(null);

  // --- Styles ---
 const styles = {
  body: { fontFamily: "Arial, sans-serif", background: "linear-gradient(to right, #e0f7fa, #e1f5fe)", margin: 0, padding: 20 },
  h1: { textAlign: "center", color: "#0277bd", textShadow: "1px 1px #fff", marginBottom: 20 },
  systemsContainer: { display: "flex", gap: 20, flexWrap: "wrap", justifyContent: "center" },
  system: { background: "#fff", border: "2px solid #0288d1", borderRadius: 10, padding: 10, minWidth: 150, maxWidth: 200, boxShadow: "2px 2px 8px rgba(0,0,0,0.1)" },
  systemH2: { textAlign: "center", color: "#01579b", margin: "0 0 10px 0" },
  folder: { border: "2px solid #0288d1", borderRadius: 8, padding: 5, margin: "8px 0", cursor: "pointer", background: "#e3f2fd", position: "relative" },
  files: { paddingLeft: 10, marginTop: 5 },
  file: { margin: "3px 0", padding: "3px 6px", borderRadius: 4, display: "flex", justifyContent: "space-between", alignItems: "center" },
  controls: { maxWidth: 950, margin: "20px auto", padding: 15, background: "#fff8e1", borderRadius: 10, border: "2px solid #ffb74d" },

  // ✅ New button style
  button: {
    background: "linear-gradient(135deg, #4CAF50, #2E7D32)",
    color: "#fff",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "2px 2px 6px rgba(0,0,0,0.15)"
  },
  buttonHover: {
    background: "linear-gradient(135deg, #43A047, #1B5E20)",
    transform: "translateY(-2px)",
    boxShadow: "3px 3px 8px rgba(0,0,0,0.25)"
  },

  accessPanel: { display: accessPanelVisible ? "block" : "none", position: "fixed", top: "20%", left: "50%", transform: "translateX(-50%)", background: "#fff", border: "2px solid #0288d1", padding: 15, borderRadius: 8, zIndex: 1000 }
};


  // --- System Creation ---
  const createSystems = () => {
    const sysArr = Array.from({ length: numSystems }, (_, i) => i);
    setSystems(sysArr);
    setFolders({});
    setSelectedFolder("");
  };

  // --- Add Folder ---
  const addFolder = () => {
    if (!folderName.trim()) return alert("Enter folder name!");
    if (folders[folderName]) return alert("Folder already exists!");
    setFolders(prev => ({ ...prev, [folderName]: { files: [], access: { 0: "owner" } } }));
    setFolderName("");
  };

  // --- Upload File ---
  const uploadFile = () => {
    if (!fileName.trim()) return alert("Enter file name!");
    if (!folders[selectedFolder]) return alert("Folder not found!");
    setFolders(prev => ({
      ...prev,
      [selectedFolder]: {
        ...prev[selectedFolder],
        files: [...prev[selectedFolder].files, { name: fileName, type: fileType }]
      }
    }));
    setFileName("");
  };

  // --- Remove Folder ---
  const removeFolder = (fName) => {
    if (!window.confirm(`Delete folder "${fName}"?`)) return;
    const newFolders = { ...folders };
    delete newFolders[fName];
    setFolders(newFolders);
  };

  // --- Remove File ---
  const removeFile = (fName, file) => {
    if (!window.confirm(`Delete file "${file}" from folder "${fName}"?`)) return;
    setFolders(prev => ({
      ...prev,
      [fName]: { ...prev[fName], files: prev[fName].files.filter(f => f.name !== file) }
    }));
  };

  // --- Access Panel ---
  const manageAccess = (fName) => {
    setCurrentFolderForAccess(fName);
    setAccessPanelVisible(true);
  };

  const applyAccess = () => {
    const newFolders = { ...folders };
    systems.forEach(idx => {
      if (idx === 0) return;
      const selectEl = document.getElementById(`accessSelect${idx}`);
      if (selectEl) {
        const val = selectEl.value;
        if (val === "none") delete newFolders[currentFolderForAccess].access[idx];
        else newFolders[currentFolderForAccess].access[idx] = val;
      }
    });
    setFolders(newFolders);
    setAccessPanelVisible(false);
  };

  return (
    <div style={styles.body}>
      <h4 style={styles.h1}>☁️ Multi-System Cloud Simulator</h4>

      <div style={styles.controls}>
        <h2>Setup Systems</h2>
        <label>Number of Systems: </label>
        <input type="number" value={numSystems} onChange={e => setNumSystems(parseInt(e.target.value))} min={1} max={5} />
        <button           style={ styles.button}
 onClick={createSystems}>Create Systems</button>
        <hr />
        <h2>Owner Controls</h2>
        <label>Folder Name:</label>
        <input type="text" value={folderName} onChange={e => setFolderName(e.target.value)} placeholder="e.g., Homework" />
        <button  
        style={ styles.button}
  
        onClick={addFolder}>Add Folder</button><br />

        <label>File Name:</label>
        <input type="text" value={fileName} onChange={e => setFileName(e.target.value)} placeholder="e.g., Math.pdf" />
        <label>Type:</label>
        <select value={fileType} onChange={e => setFileType(e.target.value)}>
          <option value="doc">Document 📄</option>
          <option value="img">Image 🖼️</option>
          <option value="vid">Video 🎬</option>
        </select>
        <label>Folder:</label>
        <select value={selectedFolder} onChange={e => setSelectedFolder(e.target.value)}>
          {Object.keys(folders).map(f => <option key={f} value={f}>{f}</option>)}
        </select>
        <button          style={ styles.button}
 onClick={uploadFile}>Upload File</button>
      </div>

      <div style={styles.systemsContainer}>
        {systems.map(idx => (
          <div key={idx} style={styles.system}>
            <h6 style={styles.systemH2}>System {idx + 1}</h6>
            <div>
              {Object.keys(folders).map(fName => (
                (folders[fName].access[idx] || idx === 0) && (
                  <div key={fName} style={styles.folder}>
                    <span>{fName}</span>
                    {idx === 0 && <button onClick={() => manageAccess(fName)}>Access</button>}
                    {idx === 0 && <button onClick={() => removeFolder(fName)}>Remove</button>}
                    <div style={styles.files}>
                      {folders[fName].files.map(file => (
                        <div key={file.name} style={{ ...styles.file, background: file.type === "doc" ? "#cce0ff" : file.type === "img" ? "#d9fcd9" : "#ffd6f0", color: file.type === "doc" ? "#003366" : file.type === "img" ? "#004d00" : "#660033" }}>
                          {file.name}
                          {(idx === 0 || folders[fName].access[idx] === "edit") && <button onClick={() => removeFile(fName, file.name)}>X</button>}
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Access Panel */}
      <div style={styles.accessPanel}>
        <h3>Manage Access for {currentFolderForAccess}</h3>
        <div>
          {systems.map(idx => {
            if (idx === 0) return null;
            const access = folders[currentFolderForAccess]?.access[idx] || "none";
            return (
              <div key={idx}>
                <label>System {idx + 1}</label>
                <select id={`accessSelect${idx}`} defaultValue={access}>
                  <option value="none">No Access</option>
                  <option value="view">View</option>
                  <option value="edit">Edit</option>
                </select>
              </div>
            );
          })}
        </div>
        <button onClick={applyAccess}>Apply</button>
        <button onClick={() => setAccessPanelVisible(false)}>Cancel</button>
      </div>
    </div>
  );
};

export default CloudSimulator;
